module.exports = __webpack_public_path__ + "static/img/y2.1415982.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3x/y2.png
// module id = 0S/D
// module chunks = 1